<template>
  <div class="sql-home-container">
    <div class="content">
      <data-source-tree
        ref="dataSourceTree"
        :current-tab="currentTab"
        :tree-data="treeData"
        :list-levels="listLevels"
        :detail-levels="detailLevels"
        :list-leaf="listLeaf"
        :get-node-data="getDataSourceNodeData"
        :get-node-by-key="getNodeByKey"
        :get-data-source-list="getDataSourceData"
        :handle-add-tab="handleAddTab"
        :set-loading="setLoading"
        :insert-node="insertNode"
        :remove-node="removeNode"
        :refresh-tab-select-options="refreshTabSelectOptions"
      />
      <div class="query-container">
        <div class="content">
          <div class="query-tab-container" v-if="tabs.length">
            <a-tabs :animated="false" @change="handleChangeTab"
                    :active-key="active"
                    hide-add size="small" type="editable-card"
                    style="width:100%;margin-left: 30px"
                    :tabBarGutter="-1">
              <a-tab-pane v-for="(tab, index) in tabs" :key="tab.key">
                <template slot="tab">
                  <a-dropdown :trigger="['contextmenu']">
                    <a-tooltip autoAdjustOverflow placement="right" :mouseEnterDelay="1">
                      <div slot="title" class="tab-hover-tip">
                        {{ tab.popTip }}
                      </div>
                      <div
                        style="user-select: none;display: flex;align-items: center;padding: 0 16px;">
                        <cc-svg-icon :name="tab.icon" style="margin-right: 5px;"/>
                        {{ tab.title }}
                        <a-icon type="close"
                                class="close-icon"
                                @click="handleEditTabs(tab.key)"/>
                      </div>
                    </a-tooltip>
                    <a-menu slot="overlay">
                      <a-menu-item @click="handleTabAction(index, TAB_ACTION.DELETE_OTHER_ALL)">
                        {{ $t('guan-bi-qi-ta-biao-qian') }}
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </template>
              </a-tab-pane>
            </a-tabs>
          </div>
          <div class="query-content-container" v-if="tabs.length">
            <loading :active.sync="fullLoading" :is-full-page="false">
            </loading>
            <div v-if="currentTab.type === TAB_TYPE.QUERY && globalDsSetting[currentTab.dsType]"
                 class="query-content">
              <div class="query-schema-select">
                <div style="display: flex;align-items: center">
                  <div class="status">
                    <Icon :type="successStatus ? 'ios-checkmark-circle' : 'ios-close-circle'" :color="successStatus ? 'green' : 'red'" size="20" v-if="successStatus" style="cursor:pointer;" @click="handleClickDsStatusIcon"/>
                    <Tooltip v-else transfer placement="left">
                      <Icon :type="successStatus ? 'ios-checkmark-circle' : 'ios-close-circle'" :color="successStatus ? 'green' : 'red'" size="20" style="cursor:pointer;" @click="handleClickDsStatusIcon"/>
                      <div slot="content">
                        <div v-if="!socket.connected">{{socket.msg}}</div>
                        <div v-if="!currentTab.connected">{{currentTab.msg}}</div>
                      </div>
                    </Tooltip>
                  </div>
                  <v-select
                    style="display: inline-block;width: 500px;margin-left: 5px;margin-right: 5px;"
                    v-model="currentTab.selectValue"
                    :options="paginated"
                    :filterable="false"
                    :clearable="false"
                    v-if="!noStruct(currentTab.node.INSTANCE.attr.dsType)"
                    label="name"
                    @open="onOpen"
                    @close="onClose"
                    @search="(query) => (search = query)"
                    @option:selected="handleChangeSchema"
                  >
                    <template #option="option">
                      <div class="query-schema-select-value">
                        <span class="db-in-select">{{ option.name }}</span>
                      </div>
                    </template>
                    <template #list-footer>
                      <li v-show="hasNextPage" ref="load" class="loader">
                        {{ $t('zheng-zai-jia-zai-geng-duo-shu-ju') }}
                      </li>
                    </template>
                    <template #no-options>
                      {{ $t('mei-you-dui-ying-de-shu-ju') }}
                    </template>
                  </v-select>
                  <div style="white-space: nowrap">@{{
                      currentTab.node.INSTANCE.attr.dsHost
                    }}【{{
                      currentTab.node.INSTANCE.attr.dsInstanceDesc || currentTab.node.INSTANCE.attr.dsInstance
                    }}】
                  </div>
                </div>
              </div>
              <div class="query">
                <TableList
                  ref="tableList"
                  :get-node-data="getTableNodeData"
                  :handle-add-tab="handleAddTab"
                  :list-leaf="listLeaf"
                  :table-list-loading="tableListLoading"
                  :currentTab="currentTab"
                  :handle-query-table="handleQueryTable"
                  :rdb-table-detail="rdbTableDetail"
                />
                <div class="query-editor-container">
                  <div class="layout-content-main">
                    <SqlViewer ref="sqlViewer"
                               :handleGetDsSetting="handleGetDsSetting"
                               :createSession="createSession"
                               :storeQueryTabs="storeQueryTabs"
                               :tab="currentTab"
                               :tabs="tabs"
                               :handle-run-async="handleRunAsync" :completion-data="completionData"
                               :rdb-table-detail="rdbTableDetail"
                               :handle-click-ds-status-icon="handleClickDsStatusIcon"
                    />
                  </div>
                  <div ref="result" class="result-wrapper">
                    <Result :id="`result_${currentTab.key}`" :ref="`result_`"
                            :resultList="currentTab.resultList"
                            :tab="currentTab"
                            :handle-run-async="handleRunAsync"/>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="currentTab.type === TAB_TYPE.STRUCT" class="query-content">
              <StructView
                :handleClickDsStatusIcon="handleClickDsStatusIcon"
                :tab="currentTab"
                :set-active-key="setActiveKey"
                :handle-refresh-tables="handleRefreshTables"
                :store-query-tabs="storeQueryTabs" ref="struct-view"/>
            </div>
            <div v-if="currentTab.type === TAB_TYPE.DATA" class="query-content">
              <lucky-sheet-data-view :tab="currentTab" ref="data-view" :set-loading="setLoading" :handle-click-ds-status-icon="handleClickDsStatusIcon"/>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="left"></div>
          <div class="right">
            <a-popover v-if="currentTab.cost && currentTab.cost.popIndex > -1">
              <template slot="content">
                <div v-for="costPop in currentTab.cost.popList" :key="costPop.text">
                  <a-icon :type="costPop.icon" :style="`color: ${costPop.color}`"
                          :theme="costPop.theme"/>
                  {{ costPop.text }}
                </div>
              </template>
              <div style="cursor: pointer">
                <a-icon :type="currentTab.cost.popList[currentTab.cost.popIndex].icon"
                        :style="`color: ${currentTab.cost.popList[currentTab.cost.popIndex].color}`"
                        :theme="currentTab.cost.popList[currentTab.cost.popIndex].theme"/>
                {{ currentTab.cost.popList[currentTab.cost.popIndex].text }}
              </div>
            </a-popover>
            <div class="btn" @click="handleToggleAsyncTaskList">
              {{ $t('hou-tai-ren-wu-asynctasklistlength', [asyncTaskList.length]) }}
            </div>
          </div>
          <div class="async-list" v-if="showAsyncTaskList">
            <div class="async-list-header">
              <div>{{ $t('hou-tai-ren-wu-lie-biao') }}</div>
              <div class="op">
                <Icon type="md-refresh" size="16" @click="listDockTask"/>
                <Icon type="md-remove" @click="handleToggleAsyncTaskList" size="16"/>
              </div>
            </div>
            <div class="list">
              <div class="task" v-for="task in asyncTaskList" :key="task.id"
                   @click="handleShowTaskDetail(task)">
                <div class="content">
                  <a-tooltip>
                    <template slot="title">
                      {{ task.title }}
                    </template>
                    <div class="title">{{ task.title }}</div>
                  </a-tooltip>
                  <div v-if="task.processType && task.processValue">
                    <a-progress
                      :percent="task.processPercent"
                      v-if="task.processType === 'PROGRESS'" status="active"/>
                    <div v-else style="display: flex;align-items: center;">
                      <a-icon type="loading" style="margin-right: 5px;"/>
                      <a-tooltip autoAdjustOverflow>
                        <template slot="title">
                          {{ task.processValue }}
                        </template>
                        <span class="title">{{ task.processValue }}</span>
                      </a-tooltip>
                    </div>
                  </div>
                </div>
                <div class="action">
                  <a-icon type="close-circle" v-if="showTaskCancelBtn(task)"
                          @click.stop="handleAsyncEventAction('cancel', task)"
                          class="async-task-btn"/>
                  <a-icon type="pause-circle" v-if="showTaskPauseBtn(task)"
                          @click.stop="handleAsyncEventAction('pause', task)"
                          class="async-task-btn"/>
                  <a-icon type="reload" v-if="showTaskRetryBtn(task)"
                          @click.stop="handleAsyncEventAction('retry', task)"
                          class="async-task-btn"/>
                  <a-icon type="play-circle" v-if="showTaskResumeBtn(task)"
                          @click.stop="handleAsyncEventAction('resume', task)"
                          class="async-task-btn"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="showConnectedModal" :title="$t('cuo-wu')">
      <div>
        {{ connectedInstance.connectedMsg }}
      </div>
      <div slot="footer">
        <Button @click="handleCloseConnectedModal(false)">{{ $t('guan-bi') }}</Button>
        <Button type="primary" @click="handleCloseConnectedModal(true)">{{ $t('zhong-xin-lian-jie') }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import deepClone from 'lodash.clonedeep';
import { Modal } from 'ant-design-vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import dayjs from 'dayjs';
import SqlViewer from '@/views/sql/components/SqlViewer';
import Result from '@/views/sql/components/Result';
import './style/index.less';
import {
  ACTION_TYPE, BIZ_TYPE, TAB_TYPE
} from '@/const';
import TableList from '@/views/sql/components/TableList';
import { isRedis } from '@/const/dataSource';
import StructView from '@/views/sql/components/StructView';
import DataSourceTree from '@/views/sql/components/DataSourceTree';
import { clearAllPending } from '@/services/http/cancelRequest';
import LuckySheetDataView from '@/views/sql/components/LuckySheetDataView';
import browseMixin from '@/mixins/browseMixin';
import { UPDATE_EDITOR_SET } from '@/store/mutationTypes';
import {
  ASYNC_TASK_STATUS, SOCKET_TYPE, hasSchema, noStruct, WS_REQ_QUERY_TYPE, WS_TYPE
} from '@/utils';
import { sendWebSocket } from '@/services/socket';
import sqlMixin from '@/mixins/sqlMixin';
import { EVENT_BUS_NAME_LIST } from '@/utils/eventBusName';

window.luckysheetData = {
  activeKey: '',
  storeUserImage: {}
};

const TAB_ACTION = {
  DELETE_ALL: 'DELETE_ALL',
  DELETE_OTHER_ALL: 'DELETE_OTHER_ALL',
  DELETE_LEFT_ALL: 'DELETE_LEFT_ALL',
  DELETE_RIGHT_ALL: 'DELETE_RIGHT_ALL'
};

export default {
  name: 'Sql',
  mixins: [browseMixin, sqlMixin],
  components: {
    LuckySheetDataView,
    DataSourceTree,
    StructView,
    SqlViewer,
    Result,
    TableList,
    Loading
  },
  data() {
    return {
      connectedInstance: {},
      showConnectedModal: false,
      showAsyncTaskList: false,
      asyncTaskList: [],
      asyncTaskObj: {},
      scrollTop: 0,
      treeInstance: null,
      tableListLoading: false,
      rdbTableDetailLoading: true,
      completionData: {},
      TAB_TYPE,
      active: '',
      treeData: [],
      newMode: true,
      TAB_ACTION,
      dataSourceWidth: 250,
      preDataSourceWidth: 0,
      ACTION_TYPE,
      observer: new IntersectionObserver(this.infiniteScroll),
      search: '',
      limit: 50,
      loading: false,
      sessionLoading: false,
      createOrDropLoading: false,
      tabs: [],
      preRequestData: {},
      currentMethod: '',
      currentTab: {
        schema: ''
      },
      showCount: 20,
      spinning: false,
      hasSchema,
      noStruct
    };
  },
  async mounted() {
    await this.listDockTask();
    await this.setDataViewImage();

    await this.getDataSourceData();
    await this.getLocalQueryData();
    window.$bus.on(EVENT_BUS_NAME_LIST.WS_RES_ASYNC_EVENT, this.handleAsyncEvent);
    window.$bus.on(EVENT_BUS_NAME_LIST.SOCKET_CONNECTION_CLOSE, this.handleSocketConnectionClose);
    window.$bus.on(EVENT_BUS_NAME_LIST.SOCKET_CONNECTION_OPEN, this.handleGetDsSetting);
    window.$bus.on(EVENT_BUS_NAME_LIST.SET_DATA_SOURCE_STATUS, (data) => this.setInstanceErrorIcon(data));
    localStorage.removeItem('sqlToTicket');
    localStorage.removeItem('instanceToTicket');
    localStorage.removeItem('databaseToTicket');
    localStorage.removeItem('schemaToTicket');
    localStorage.removeItem('dsTypeToTicket');
  },
  computed: {
    fullLoading() {
      return this.loading;
    },
    successStatus() {
      return this.socket.connected && this.currentTab.connected;
    },
    ...mapState(['globalDsSetting', 'userInfo', 'socket']),
    ...mapGetters([
      'isDesktop',
      'getNodeType',
      'getLeafGroup',
      'getQuickQuery',
      'getLevels'
    ]),
    filtered() {
      return this.currentTab.selectOptions.filter((item) => item.includes(this.search));
    },
    paginated() {
      return this.filtered.slice(0, this.limit);
    },
    hasNextPage() {
      return this.paginated.length < this.filtered.length;
    }
  },
  methods: {
    async handleCloseConnectedModal(reConnected = true) {
      this.showConnectedModal = false;
      if (reConnected) {
        await this.handleTestConnect();
      }
    },
    handleSocketConnectionClose() {
      this.tabs.forEach((tab) => {
        tab.stopping = false;
        tab.running = false;
        tab.message = {
          text: '',
          show: false,
          type: ''
        };
        tab.cost = {
          popIndex: -1,
          popList: []
        };
      });
    },
    ...mapMutations([UPDATE_EDITOR_SET]),
    isRedis,
    getTreeData() {
      const treeData = this.$refs.dataSourceTree.handleGetTreeData();
      return treeData;
    },
    async getDataSourceData() {
      this.treeData = [];
      await this.listLevels();
      if (this.treeData.length) {
        await this.listLevels(this.treeData[0]);
      }
    },
    setDataViewImage() {
      const pkImg = new Image();
      pkImg.src = 'data:image/png;base64,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';
      window.luckysheetData.storeUserImage.pkImg = pkImg;

      const ukImg = new Image();
      ukImg.src = 'data:image/png;base64,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';
      window.luckysheetData.storeUserImage.ukImg = ukImg;
    },
    removeNode(tree, parentKey, key) {
      if (parentKey && key) {
        const parentNode = this.getNodeByKey(tree, parentKey);
        parentNode.children = parentNode.children.filter((node) => node.key !== key);
      }
    },
    insertNode(parentKey, key, node) {
      const parentNode = this.getNodeByKey(this.treeData, parentKey);
      if (key) {
        const nodeIndex = parentNode.children.findIndex((child) => child.key === key);
        parentNode.children.splice(nodeIndex + 1, 0, node);
      } else {
        parentNode.children.unshift(node);
      }
    },
    getNodeByKey(tree, curKey, keyField = 'key', node = null) {
      const stack = [];
      for (const item of tree) {
        if (item) {
          stack.push(item);
          while (stack.length) {
            const temp = stack.pop();

            if (temp[keyField] === curKey) {
              node = temp;
              break;
            }

            const children = temp.children || [];
            for (let i = children.length - 1; i >= 0; i--) {
              stack.push(children[i]);
            }
          }
        }
      }
      return node;
    },
    async detailLevels(node, callback) {
      const res = await this.$services.detailLevels({
        data: {
          levels: this.browseGenLevelsData(node)
        }
      });

      if (res.success) {
        const curNode = this.getNodeByKey(this.treeData, node.key);
        if (curNode) {
          const {
            objId, objName, objAttr, objType
          } = res.data;
          curNode[objType] = {
            id: objId === -1 ? objName : objId,
            name: objName,
            attr: objAttr
          };
          curNode.title = objName;
          curNode.popTip = `${node.parentPoptip}.${objName}`;
          curNode.key = `${node.parentKey}.\`${objId === -1 ? objName : objId}\``;
        }

        await this.$refs.dataSourceTree.handleSetData(this.treeData);
        this.$refs.dataSourceTree.handleSetSelected(curNode.key);

        if (callback) {
          callback();
        }
      }
    },
    async listLevels(node = null, params = {}, resolve = () => {
    }) {
      let curNode = null;
      if (node) {
        curNode = this.getNodeByKey(this.treeData, node.key);
        curNode.children = [];
      } else {
        this.treeData = [];
      }

      try {
        const levelRes = await this.$services.listLevels({ data: { levels: node ? this.browseGenLevelsData(node) : [], cancelPending: true } });
        if (levelRes.success && levelRes.data && levelRes.data.length) {
          levelRes.data.forEach((level) => {
            const {
              objId, objName, objType, objAttr = null
            } = level;
            if (node) {
              if (this.completionData[node.key]) {
                this.completionData[node.key].push(level);
              } else {
                this.completionData[node.key] = [level];
              }
              const preLevels = [...node.levels];
              const leaf = {};
              preLevels.forEach((levelKey) => {
                leaf[levelKey] = node[levelKey];
              });
              Object.assign(leaf, {
                [objType]: {
                  id: objId === -1 ? objName : objId,
                  name: objName,
                  attr: objAttr
                },
                icon: objType === 'INSTANCE' ? objAttr.dsType : objType,
                isLeaf: false,
                selected: params.selected === `${node.key}.\`${objId === -1 ? objName : objId}\``,
                title: objName,
                popTip: `${node.popTip}.${objName}`,
                parentKey: node.key,
                parentPoptip: node.popTip,
                key: `${node.key}.\`${objId === -1 ? objName : objId}\``,
                children: [],
                nodeType: objType,
                levels: [...preLevels, objType]
              });

              if (objType === 'INSTANCE') {
                leaf.connected = objAttr.status === 'Normal';
                leaf.connectedMsg = objAttr.msg;
              }

              const dsLevels = this.getLevels(leaf.INSTANCE.attr.dsType);
              if (dsLevels && dsLevels.length === leaf.levels.length) {
                leaf.isLeaf = true;
              }
              curNode.children.push(leaf);
            } else {
              const leaf = {
                [objType]: {
                  id: objId,
                  name: objName
                },
                icon: objType,
                isLeaf: false,
                popTip: objName,
                title: objName,
                key: `\`${objId}\``,
                children: [],
                nodeType: objType,
                levels: [objType]
              };
              this.treeData.push(leaf);
            }
          });

          if (node) {
            this.$refs.dataSourceTree.handleSetExpandedKeys(node);
          }

          if (levelRes.data.length) {
            await this.$refs.dataSourceTree.handleSetData(this.treeData, true);
            if (node) {
              await this.$refs.dataSourceTree.handleSetSelected(node.key);
            }
          } else {
            resolve();
          }
        } else {
          console.log('fail');
          if (typeof levelRes === 'object' && levelRes.toString().includes('Cancel')) {
            console.log('reset');
            return;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    setInstanceErrorIcon(data) {
      this.treeData.forEach((env) => {
        if (env.children) {
          env.children.forEach((instance) => {
            if (instance.INSTANCE.id === data.instanceId) {
              instance.connected = data.connected;
              instance.connectedMsg = data.msg;
              if (this.currentTab.node.INSTANCE.id === data.instanceId) {
                this.currentTab.connected = data.connected;
                this.currentTab.msg = data.msg;
              }
              if (this.$refs.dataSourceTree) {
                this.$refs.dataSourceTree.handleSetData(this.treeData);
              }
              if (!data.connected) {
                this.showConnectedModal = true;
                this.connectedInstance = { code: data.code, ...instance };
              }
            }
          });
        }
      });
    },
    handleChangeSchema(event) {
      const { node, schemaParentKey, prefix } = this.currentTab;
      if (event) {
        const lastLevel = node.levels[node.levels.length - 1];
        node[lastLevel].name = event;
        node[lastLevel].id = event;
        node.key = `${schemaParentKey}.\`${event}\``;
        this.currentTab.key = `${prefix}.${schemaParentKey}.\`${event}\``;
        const sameIndex = this.tabs.findIndex((tab) => tab.key === this.currentTab.key);
        if (sameIndex > -1) {
          this.currentTab.key = `${prefix}.${schemaParentKey}.\`${event}\`.\`${dayjs().valueOf()}\``;
        }
        this.currentTab.prefixKey = this.currentTab.key;
        this.currentTab.title = event;
        const { levels } = node;
        let popTip = '';
        const node2 = {
          levels
        };
        levels.forEach((level) => {
          node2[level] = node[level];
          popTip += `${node[level].name}.`;
        });
        if (popTip) {
          popTip = popTip.substring(0, popTip.lastIndexOf('.'));
        }
        this.currentTab.popTip = popTip;
        this.listLeaf();
      }

      this.active = this.currentTab.key;
      this.currentTab.message.show = false;
      sendWebSocket({
        type: WS_TYPE.WS_REQ_QUERY,
        object: {
          sessionId: this.currentTab.sessionId,
          queryType: WS_REQ_QUERY_TYPE.SWITCH_CTX,
          levels: this.browseGenLevelsData(this.currentTab.node)
        }
      }, { message: this.$refs.sqlViewer.onmessage });
    },
    async listLeaf() {
      const { node, leafType } = this.currentTab;

      this.tableListLoading = true;

      const leafList = [];

      try {
        const leafRes = await this.$services.listLeaf({
          data: {
            levels: node.levels.map((l) => this.currentTab.node[l].id),
            leafType
          }
        });

        if (leafRes.success) {
          const completionKey = node.key;

          const obj = {};
          leafRes.data.forEach((leaf) => {
            const { objName, objType, objAttr } = leaf;
            obj[objName] = leaf;
            leafList.push({
              title: objName,
              key: `${node.key}.\`${objName}\``,
              leafKey: `${node.key}.\`${objName}\``,
              nodeType: objType,
              children: [],
              icon: objType,
              isRoot: true,
              objAttr,
              isLeaf: !['TABLE', 'VIEW', 'FUNC', 'PROC'].includes(objType)
            });
          });

          if (this.completionData[completionKey]) {
            this.completionData[completionKey][leafType] = obj;
          } else {
            this.completionData[completionKey] = { [leafType]: obj };
          }

          this.currentTab[leafType].treeData = leafList;
          await this.$refs.tableList.handleSetData(leafList);
          await this.$refs.tableList.handleFilter(this.currentTab[this.currentTab.leafType].searchKey);
        } else {
          this.setInstanceErrorIcon(this.currentTab?.node?.INSTANCE?.id);
          if (this.$refs.tableList) {
            await this.$refs.tableList.handleSetData(leafList);
          }
        }
      } catch (e) {
        this.setInstanceErrorIcon(this.currentTab?.node?.INSTANCE?.id);
        if (this.$refs.tableList) {
          await this.$refs.tableList.handleSetData(leafList);
        }
      } finally {
        this.tableListLoading = false;
      }

      this.storeQueryTabs();
    },
    async handleAddTab(type, node, options = {}) {
      if (this.disableAddTab()) {
        return;
      }
      this.storeQueryTabs();
      const prefix = `tab_${type}${options.editorType ? `_${options.editorType}` : ''}`;
      const prefixKey = `${prefix}.${node.key}`;
      const key = `${prefixKey}${options.table ? `.\`${options.table.title}\`` : ''}${options.force ? `.${dayjs().valueOf()}` : ''}`;

      let hasSameTab = false;
      for (let i = 0; i < this.tabs.length; i++) {
        if (key === this.tabs[i].key) {
          this.active = key;
          this.currentTab = this.tabs[i];
          hasSameTab = true;
        }
      }

      if (hasSameTab) {
        if (type === TAB_TYPE.QUERY) {
          await this.createSession(this.currentTab);
          await this.listLeaf();
        }
        return;
      }

      const { levels } = node;
      let popTip = '';
      const node2 = {
        levels
      };
      levels.forEach((level) => {
        node2[level] = node[level];
        popTip += `${node[level].name}.`;
      });
      if (popTip) {
        popTip = popTip.substring(0, popTip.lastIndexOf('.'));
      }
      node2.children = node.children;
      node2.key = node.key;
      const tab = {
        node: node2,
        dsType: node.INSTANCE.attr.dsType,
        dsId: node.INSTANCE.id,
        popTip,
        running: false,
        type,
        prefix,
        key,
        prefixKey,
        title: node.title,
        loading: false,
        cost: {
          popIndex: -1,
          popList: []
        }
      };

      const res = await this.$services.fetchDsStatusConf({
        data: {
          dsId: tab.dsId
        }
      });

      if (res.success) {
        tab.support = res.data;
        tab.connected = res.data.dsStatus === 'Normal';
        tab.msg = res.data.dsStatusMessage;
        if (res.data.autoCommit) {
          tab.autoCommit = res.data.autoCommit.defaultValue;
        }
        if (res.data.readOnly) {
          tab.readOnly = res.data.readOnly?.defaultValue === 'true';
        }
        if (res.data.isolation) {
          tab.isolation = res.data.isolation?.defaultValue;
        }
      }

      switch (type) {
        case TAB_TYPE.QUERY:
          tab.schemaParentKey = node._parent.key;
          tab.selectOptions = node._parent.children.map((child) => child.title);
          tab.leafGroup = [];
          tab.selectValue = node.title;
          tab.selectedTable = null;
          tab.message = {
            text: '',
            show: false,
            type: ''
          };
          tab.expandedKeys = [];
          tab.result = {
            active: 'message',
            list: []
          };
          tab.text = '';
          tab.icon = node.INSTANCE.attr.dsType;
          tab.sessionId = '';
          tab.executeInfo = [];
          const leafGroup = this.getLeafGroup(tab.node.INSTANCE.attr.dsType);
          if (leafGroup && leafGroup.length) {
            tab.leafGroup = leafGroup;
            tab.leafType = leafGroup[0].type;
            leafGroup.forEach((tabKey) => {
              tab[tabKey.type] = {
                ...tabKey,
                searchKey: '',
                treeData: []
              };
            });
          }
          break;
        case TAB_TYPE.DATA:
          tab.icon = 'data';
          Object.assign(tab, {
            title: this.$t('optionstabletitle-biao-de-shu-ju', [options.table.title]),
            targetType: this.currentTab.leafType,
            selectedTable: {
              title: options.table ? options.table.title : ''
            },
            updateCellList: [],
            addRows: [],
            deleteRows: [],
            currentSortConfig: {},
            whereKeyList: [],
            offset: 0,
            pageSize: 50,
            selectedPageKeys: ['50'],
            hasNext: false,
            isFirst: false,
            total: null,
            condition: '',
            orderBy: '',
            rawTableData: {
              resultSet: [],
              resultSetMore: []
            },
            columns: [],
            columnWithoutHidden: []
          });
          break;
        case TAB_TYPE.STRUCT:
          tab.icon = 'struct';
          Object.assign(tab, {
            title: options.editorType === ACTION_TYPE.EDIT_TABLE ? this.$t('optionstabletitle-biao-de-jie-gou', [options.table.title]) : this.$t('xin-jian-biao'),
            editorType: options.editorType,
            selectedTable: {
              title: options.table ? options.table.title : ''
            },
            selectedKeys: [],
            selectedData: {},
            selectedIndex: -1,
            expandedKeys: [],
            nodeType: '',
            formData: {
              tableInfo: {}
            },
            originFormData: {},
            initTableData: {
              tableInfo: {}
            },
            selectedNode: null,
            selectedSchema: null,
            schemaDef: {},
            treeData: [],
            init: false
          });
          break;
        default:
          break;
      }

      this.tabs.push(tab);
      this.active = key;
      this.currentTab = tab;

      switch (type) {
        case TAB_TYPE.QUERY:
          await this.createSession(this.currentTab);
          await this.listLeaf();
          break;
        case TAB_TYPE.STRUCT:
        case TAB_TYPE.DATA:
          break;
        default:
          break;
      }

      this.storeQueryTabs();
    },
    refreshTabSelectOptions(key) {
      const node = this.$refs.dataSourceTree.handleGetNode(key);
      if (node.key && node._parent && node._parent.children) {
        this.tabs.forEach((tab) => {
          if (tab.type === TAB_TYPE.QUERY && tab.schemaParentKey === key) {
            tab.selectOptions = node.children.map((child) => child.title);
          }
        });
        this.storeQueryTabs();
      }
    },
    cancelAllLoading() {
      this.loading = false;
      this.sessionLoading = false;
      this.createOrDropLoading = false;
      this.tableListLoading = false;
    },
    setLoading(loading) {
      this.loading = loading;
    },
    async handleRunAsync(selectedSql, asyncForm) {
      const data = {
        ddlSqlExecType: asyncForm.ddl,
        noneDdlSqlExecType: asyncForm.noneDdl,
        dataSourceId: this.currentTab.instanceId,
        exportSqls: selectedSql,
        bizType: BIZ_TYPE.QUERY_CONSOLE,
        dataSourceType: this.currentTab.dataSourceType,
        exportToFile: asyncForm.exportToFile,
        currentDb: this.currentTab.schema ? this.currentTab.database : null,
        currentSchema: this.currentTab.schema || this.currentTab.database,
        exportBizId: this.currentTab.sessionId
      };
      const res = await this.$services.submitExportJob({ data });
      if (res.success) {
        this.$message.success(this.$t('yi-bu-ren-wu-ti-jiao-cheng-gong'));
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[1].text.toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.limit += 50;
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    async getLocalQueryData() {
      const localData = localStorage.getItem(`clouddm_new_tabs_${this.userInfo.uid}`);
      if (localData) {
        const data = JSON.parse(localData);
        this.active = data.active;
        this.tabs = data.tabData || [];
        if (this.tabs.length) {
          let hasActiveKey = false;
          this.tabs.forEach((tab) => {
            if (!tab.dsId && tab.node) {
              tab.dsId = tab.node.INSTANCE.id;
            }
            tab.message = {
              text: '',
              show: false,
              type: ''
            };
            tab.cost = {
              popIndex: -1,
              popList: []
            };
            tab.executeInfo = [];
            if (tab.leafGroup) {
              tab.leafGroup.forEach((leaf) => {
                tab[leaf.type] = {
                  searchKey: '',
                  treeData: []
                };
              });
            }
            if (tab.key === this.active) {
              this.currentTab = tab;
              hasActiveKey = true;
            }
          });

          if (hasActiveKey) {
            await this.handleGetDsSetting();
            if (this.currentTab.type === TAB_TYPE.QUERY && this.currentTab.connected) {
              await this.listLeaf();
            }
          }
        }
      }
    },
    storeQueryTabs() {
      const { uid } = this.userInfo;
      const key = `clouddm_new_tabs_${uid}`;

      if (this.currentTab.type === TAB_TYPE.QUERY && this.$refs.sqlViewer && this.$refs.sqlViewer.monacoEditor) {
        this.currentTab.text = this.$refs.sqlViewer.monacoEditor.getValue();
      }

      const tabData = deepClone(this.tabs);
      tabData.forEach((tab) => {
        if (tab.leafGroup) {
          tab.leafGroup.forEach((leaf) => {
            tab[leaf.type] = {
              searchKey: '',
              treeData: []
            };
          });
        }

        if (tab.node && tab.node.children) {
          tab.node.children = [];
        }
        tab.expandedKeys = [];
        tab.updateCellList = [];
        tab.addRows = [];
        tab.deleteRows = [];
        tab.currentSortConfig = {};
        tab.whereKeyList = [];
        tab.selectedRowKeys = [];
        tab.startEditing = false;
        tab.selectedCell = {
          rowIndex: -1,
          column: {},
          row: {}
        };

        tab.result = {
          active: 'message',
          list: []
        };
        tab.executeInfo = [];
        tab.showAsyncListTab = false;
        tab.schemaList = [];
        tab.allSchemaList = [];
        tab.childrenList = [];
        tab.running = false;
      });
      localStorage.setItem(key, JSON.stringify({ active: this.active, tabData }));
    },
    getDataSourceNodeData(node, params = {}, resolve = () => {
    }, reject) {
      if (node && !node.isLeaf) {
        this.listLevels(node, params, resolve, reject);
      } else {
        resolve();
      }
    },
    getTableNodeData(node, params, resolve) {
      if (node && !node.isLeaf) {
        this.rdbTableDetail(node.title, { ...params, expand: true, selected: true }, resolve);
      } else {
        resolve();
      }
    },
    async rdbTableDetail(tableName, params = { expand: true, selected: true }, resolve = () => {
    }) {
      const {
        expand, selected, selectedNode
      } = params;
      const { node } = this.currentTab;
      try {
        const res = await this.$services.rdbTableDetail({
          data: {
            levels: this.browseGenLevelsData(this.currentTab.node),
            targetName: tableName,
            targetType: this.currentTab.leafType
          }
        });

        if (res.success) {
          const curNode = this.getNodeByKey(this.currentTab[this.currentTab.leafType].treeData, `${node.key}.\`${tableName}\``);
          const children = [];
          const columnList = [];
          res.data.group.forEach((groupItem) => {
            const child = {
              nodeType: groupItem.type,
              title: groupItem.name,
              key: `${node.key}.\`${tableName}\`.${groupItem.type}`,
              leafKey: curNode.leafKey,
              isLeaf: groupItem.items.length === 0,
              icon: 'folder',
              children: []
            };
            groupItem.items.forEach((column) => {
              const item = {
                title: column.name,
                key: `${child.key}.\`${column.name}\``,
                leafKey: child.leafKey,
                icon: column.icon || column.type,
                tips: column.tips && `(${column.tips})`,
                nodeType: column.type,
                isLeaf: true
              };
              child.children.push(item);
              if (groupItem.type === 'RDB_COLUMN_GROUP') {
                columnList.push(item);
              }
            });
            if (child.children.length) {
              children.push(child);
              if (expand) {
                console.log('set expand');
                this.$refs.tableList.handleSetExpandedKeys(child);
              }
            }
          });

          curNode.children = children;
          this.completionData[this.currentTab.node.key][this.currentTab.leafType][tableName].columnList = columnList;
          await this.$refs.tableList.handleSetData(this.currentTab[this.currentTab.leafType].treeData);
          if (selected) {
            if (selectedNode) {
              this.$refs.tableList.handleSetSelected(selectedNode);
            } else {
              this.$refs.tableList.handleSetSelected(curNode);
            }
          }
          this.setInstanceErrorIcon(this.currentTab?.node?.INSTANCE?.id, true);
          resolve();
        } else {
          this.setInstanceErrorIcon(this.currentTab?.node?.INSTANCE?.id);
          await this.$refs.tableList.handleSetData(this.currentTab[this.currentTab.leafType].treeData);
        }
      } catch (e) {
        console.log(e);
        this.setInstanceErrorIcon(this.currentTab?.node?.INSTANCE?.id);
        await this.$refs.tableList.handleSetData(this.currentTab[this.currentTab.leafType].treeData);
      }
    },
    async closesSession(tabs) {
      const sessionId = [];
      tabs.forEach((tab) => {
        if (tab.sessionId) {
          sessionId.push(tab.sessionId);
        }
      });

      await this.$services.closesSession({ data: { sessionId } });
    },
    handleTabAction(index, actionType) {
      switch (actionType) {
        case TAB_ACTION.DELETE_ALL:
          this.tabs = [];
          this.active = '';
          break;
        case TAB_ACTION.DELETE_OTHER_ALL:
          this.currentTab = this.tabs[index];
          const tabs = [];
          for (let i = 0; i < this.tabs.length; i++) {
            if (i !== index) {
              tabs.push(this.tabs[i]);
            }
          }
          this.closesSession(tabs);
          this.tabs = [this.currentTab];
          this.active = this.currentTab.key;
          break;
        case TAB_ACTION.DELETE_LEFT_ALL:
          break;
        case TAB_ACTION.DELETE_RIGHT_ALL:
          break;
        default:
          break;
      }

      this.storeQueryTabs();
    },
    handleEditTabs(targetKey) {
      const editTabList = this.tabs.filter((tab) => tab.key === targetKey);
      if (editTabList.length) {
        const editTab = editTabList[0];
        if (editTab.type === 'DATA' && this.dataViewIsEditing(editTab)) {
          Modal.confirm({
            title: this.$t('ti-shi'),
            content: this.$t('dang-qian-ye-mian-huan-you-wei-ti-jiao-de-xiu-gai-qing-xian-ti-jiao-hou-guan-bi-dian-ji-li-ji-guan-bi-jiang-diu-shi-dang-qian-xiu-gai'),
            okText: this.$t('li-ji-guan-bi'),
            onOk: () => this.removeTab(targetKey)
          });
        } else if (editTab.type === 'STRUCT' && this.structViewIsEditing(editTab)) {
          Modal.confirm({
            title: this.$t('ti-shi'),
            content: this.$t('dang-qian-biao-jie-gou-huan-you-wei-ti-jiao-de-xiu-gai-qing-xian-ti-jiao-hou-guan-bi-dian-ji-li-ji-guan-bi-jiang-diu-shi-dang-qian-xiu-gai'),
            okText: this.$t('li-ji-guan-bi'),
            onOk: () => this.removeTab(targetKey)
          });
        } else {
          this.removeTab(targetKey);
        }
      }
    },
    removeTab(key) {
      let deleteIndex = 0;
      this.tabs.forEach((tab, index) => {
        if (tab.key === key) {
          deleteIndex = index;
          this.tabs.splice(index, 1);
          this.closesSession([tab]);
        }
      });

      const len = this.tabs.length;
      if (len > 0) {
        const activeIndex = deleteIndex ? deleteIndex - 1 : 0;
        this.active = this.tabs[activeIndex].key;
        delete window.luckysheetData[this.active];
        window.luckysheetData.activeKey = this.active;
        this.handleChangeTab(this.active, true);
      } else {
        this.active = '';
        this.currentTab = {};
      }

      this.storeQueryTabs();
    },
    async createSession(tab, next) {
      this.sessionLoading = true;
      const { node, autoCommit, isolation } = tab;

      try {
        const res = await this.$services.createSession({
          data: {
            levels: this.browseGenLevelsData(node),
            initAutoCommit: autoCommit,
            initIsolation: isolation
          }
        });
        if (res.success) {
          this.tabs.forEach((item) => {
            if (item.key === tab.key) {
              item.sessionId = res.data.sessionId;
            }
          });
          if (next) {
            next();
          }
        }
      } finally {
        this.sessionLoading = false;
      }
    },
    handleQueryTable(text) {
      this.$refs.sqlViewer.setSql(text);
    },
    disableAddTab() {
      if (this.tabs.length >= 20) {
        Modal.warning({
          title: this.$t('chuang-kou-shang-xian-ti-shi'),
          content: this.$t('ni-kai-qi-de-chuang-kou-shu-liang-yi-da-shang-xian-qing-guan-bi-qi-ta-chuang-kou-hou-zhong-xin-cao-zuo'),
          okText: this.$t('que-ding')
        });
      }

      return this.tabs.length >= 20;
    },
    setActiveKey(key) {
      this.active = key;
    },
    handlePreRequest() {
      if (this.currentMethod === 'listFirstLevel') {
        const {
          instance,
          callback
        } = this.preRequestData;
        this.listFirstLevel(instance, callback);
      } else if (this.currentMethod === 'creatession') {
        const {
          tab
        } = this.preRequestData;
        this.createSession(tab);
      }
    },
    handleGoTicket() {
      const {
        instanceId, database, schema, dataSourceType
      } = this.currentTab;
      this.$router.push({
        path: '/ticket_create'
      });
    },
    async handleChangeTab(activeKey, force = false) {
      console.log('change tab');
      const changeTab = async (key) => {
        if (this.$refs['data-view']) {
          this.$refs['data-view'].handleEmptyUpdate();
        }
        this.$nextTick(async () => {
          this.tabs.forEach((item) => {
            if (item.key === key) {
              clearAllPending();
              this.cancelAllLoading();
              this.storeQueryTabs();
              this.currentTab = item;
              this.active = key;
              if (this.$refs.tableList && item.leafType && item[item.leafType] && item[item.leafType].treeData) {
                this.$refs.tableList.selectedNode = null;
                this.$refs.tableList.handleSetData(item[item.leafType].treeData);
              }
            }
          });
          await this.handleGetDsSetting();
        });
      };
      if (this.$refs['data-view'] && this.$refs['data-view'].isEditing && !force) {
        Modal.confirm({
          title: this.$t('jing-gao'),
          content: this.$t('dang-qian-ye-mian-you-wei-ti-jiao-de-xiu-gai-dian-ji-que-ding-jiang-qie-huan-biao-qian-ye-bing-diu-shi-xiu-gai'),
          onOk: async () => {
            await changeTab(activeKey);
          }
        });
      } else {
        await changeTab(activeKey);
      }
    },
    async handleTestConnect() {
      if (this.connectedInstance.ENV.id && this.connectedInstance.INSTANCE.id) {
        try {
          const res = await this.$services.testConnect({
            data: {
              levels: [this.connectedInstance.ENV.id, this.connectedInstance.INSTANCE.id]
            }
          });
        } catch (e) {
          console.log(e);
        }
      }
    },
    async handleClickDsStatusIcon() {
      if (this.currentTab && this.currentTab.node.ENV?.id && this.currentTab.node.INSTANCE?.id) {
        try {
          const res = await this.$services.testConnect({
            data: {
              levels: [this.currentTab.node.ENV.id, this.currentTab.node.INSTANCE.id]
            }
          });
        } catch (e) {
          console.log(e);
        }
      }
    },
    async handleGetDsSetting() {
      if (this.currentTab && this.currentTab.dsId) {
        const res = await this.$services.fetchDsStatusConf({
          data: {
            dsId: this.currentTab.dsId
          }
        });

        if (res.success) {
          this.currentTab.support = res.data;
          this.currentTab.connected = res.data.dsStatus === 'Normal';
          this.currentTab.msg = res.data.dsStatusMessage;
          if (res.data.autoCommit) {
            this.currentTab.autoCommit = res.data.autoCommit.defaultValue;
          }
          if (res.data.readOnly) {
            this.currentTab.readOnly = res.data.readOnly?.defaultValue === 'true';
          }
          if (res.data.isolation) {
            this.currentTab.isolation = res.data.isolation?.defaultValue;
          }
        }
      }
    },
    async getRedisKey() {
      this.spinning = true;

      const res = await this.$services.topKeysWithLimit({
        data: {
          dataSourceId: this.currentTab.instanceId,
          pattern: this.currentTab.searchKey || '*'
        }
      });
      if (res.success) {
        const keysData = [];
        res.data.forEach((data) => {
          keysData.push({
            name: data,
            type: 'KEY'
          });
        });
        this.currentTab.keyList = keysData || [];
        this.currentTab.filteredKeyList = deepClone(this.currentTab.keyList) || [];
        this.currentTab.showKeyList = this.currentTab.filteredKeyList.slice(0, this.currentTab.pageData.size);

        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
      this.spinning = false;
    },
    async handleRefreshTables(tabSetting = {}) {
      this.listTableLoading = true;
      if (tabSetting.type === 'key') {
        await this.getRedisKey();
      } else {
        await this.getTableList(tabSetting);
      }
      this.listTableLoading = false;
    },
    async handleShowTaskDetail(task) {
      window.$bus.emit('showFakerModal', task);
    },
    async handleAsyncEventAction(actionType, task) {
      let res;
      let msg;
      switch (actionType) {
        case 'cancel':
          res = await this.$services.asyncTaskCancelTask({
            data: {
              taskId: task.id
            }
          });
          msg = this.$t('qu-xiao-cheng-gong');
          break;
        case 'pause':
          res = await this.$services.asyncTaskPauseTask({
            data: {
              taskId: task.id
            }
          });
          msg = this.$t('zan-ting-cheng-gong');
          break;
        case 'retry':
          res = await this.$services.asyncTaskRetryTask({
            data: {
              taskId: task.id
            }
          });
          msg = this.$t('zhong-shi-cheng-gong');
          break;
        case 'resume':
          res = await this.$services.asyncTaskResumeTask({
            data: {
              taskId: task.id
            }
          });
          msg = this.$t('hui-fu-cheng-gong');
          break;
        default:
          break;
      }

      if (res.success) {
        this.$message.success(msg);
      }
    },
    showTaskCancelBtn(task) {
      const { INIT, BLOCK, RUNNING } = ASYNC_TASK_STATUS;
      return [INIT, BLOCK, RUNNING].includes(task.status);
    },
    showTaskPauseBtn(task) {
      const { BLOCK, RUNNING } = ASYNC_TASK_STATUS;
      return [BLOCK, RUNNING].includes(task.status);
    },
    showTaskRetryBtn(task) {
      const { FAILURE, CANCEL } = ASYNC_TASK_STATUS;
      return [FAILURE, CANCEL].includes(task.status);
    },
    showTaskResumeBtn(task) {
      const { PAUSE } = ASYNC_TASK_STATUS;
      return [PAUSE].includes(task.status);
    },
    async handleToggleAsyncTaskList() {
      await this.listDockTask();
      if (this.asyncTaskList.length && !this.showAsyncTaskList) {
        this.showAsyncTaskList = true;
      } else {
        this.showAsyncTaskList = false;
      }
    },
    async listDockTask() {
      const res = await this.$services.asyncTaskListDockTask();

      if (res.success) {
        this.asyncTaskList = res.data.map((task) => {
          if (task.processType === 'PROGRESS' && task.processValue) {
            task.processPercent = parseFloat(task.processValue);
          }

          return task;
        });
      }
    },
    handleAsyncEvent(data) {
      const { object } = data;
      if (object.processType === 'PROGRESS' && object.processValue) {
        object.processPercent = parseFloat(object.processValue);
      }
      const index = this.asyncTaskList.findIndex((task) => task.id === object.id);
      if (index > -1) {
        if (object.status === 'COMPLETE' || object.status === 'CANCEL') {
          this.asyncTaskList.splice(index, 1);
          if (!this.asyncTaskList.length) {
            this.showAsyncTaskList = false;
          }
        } else {
          this.asyncTaskList[index] = object;
        }
      }
      if (index === -1 && object.status === 'RUNNING') {
        this.asyncTaskList.unshift(object);
        this.showAsyncTaskList = true;
      }

      this.$forceUpdate();
    }
  },
  beforeDestroy() {
    window.$bus.off(EVENT_BUS_NAME_LIST.WS_RES_ASYNC_EVENT);
    window.$bus.off(EVENT_BUS_NAME_LIST.SOCKET_CONNECTION_OPEN);
    window.$bus.off(EVENT_BUS_NAME_LIST.SOCKET_CONNECTION_CLOSE);
    window.$bus.off(EVENT_BUS_NAME_LIST.SET_DATA_SOURCE_STATUS);
  }
};
</script>
<style scoped lang="less">

.footer {
  height: 24px;
  width: 100%;
  border-top: 1px solid #ccc;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .right {
    display: flex;
    align-items: center;

    .btn {
      font-size: 12px;
    }
  }

  .async-list {
    position: absolute;
    width: 400px;
    max-height: 400px;
    overflow: auto;
    bottom: 24px;
    border: 1px solid #ccc;
    border-bottom: none;
    z-index: 999;
    background: #fff;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;

    .async-list-header {
      height: 24px;
      border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;

      .op {
        display: flex;
        align-items: center;
      }
    }

    .list {
      padding: 5px;

      .task {
        padding: 3px;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 5px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
        width: 100%;

        .content {
          flex: 1;
          min-width: 0;
          margin-right: 40px;

          .title {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
          }
        }

        .action {
          .async-task-btn + .async-task-btn {
            margin-left: 5px;
          }
        }
      }
    }
  }
;
}

.close-icon {
  cursor: pointer;
  margin-left: 3px !important;
  margin-right: -5px !important;
  padding: 2px;

  &:hover {
    background: #eee;
    border-radius: 50%;
  }
}

.tab-hover-tip {
  white-space: nowrap;
}

/deep/ .ant-tabs-tab {
  padding: 0 !important;
}
</style>
